<form  (ngSubmit)="onSubmit()" [formGroup]="frmReporte">
<h2 mat-dialog-title>{{ data.title }}</h2>
<mat-dialog-content>
  <div class="row">
    @if (hasParam ('pAnio')) {
      <div class="col-md-6 col-sm-12">
        <mat-form-field class="full-width">
          <mat-label>Año</mat-label>
          <input matInput type="number" formControlName="anio" min="1900" step="1">
        </mat-form-field>
      </div>
    }
    @if (hasParam ('pNumero')) {
      <div class="col-md-6 col-sm-12">
        <mat-form-field class="full-width">
          <mat-label>Número</mat-label>
          <input matInput type="number" formControlName="numero" min="1" step="1">
        </mat-form-field>
      </div>
    }
    @if (hasParam ('pFechaInicio')) {
      <div class="col-md-6 col-sm-6">
        <mat-form-field class="full-width">
          <mat-label>Fecha inicio</mat-label>
          <input matInput [matDatepicker]="fechaInicio" formControlName="fechaInicio">
          <mat-hint>DD/MM/YYYY</mat-hint>
          <mat-datepicker-toggle matIconSuffix [for]="fechaInicio"></mat-datepicker-toggle>
          <mat-datepicker #fechaInicio></mat-datepicker>
        </mat-form-field>
      </div>
    }
    @if (hasParam ('pFechaFin')) {
      <div class="col-md-6 col-sm-6">
        <mat-form-field class="full-width">
          <mat-label>Fecha fin</mat-label>
          <input matInput [matDatepicker]="fechaFin" formControlName="fechaFin">
          <mat-hint>DD/MM/YYYY</mat-hint>
          <mat-datepicker-toggle matIconSuffix [for]="fechaFin"></mat-datepicker-toggle>
          <mat-datepicker #fechaFin></mat-datepicker>
        </mat-form-field>
      </div>
    }
    @if (hasParam ('pTipoDocumento')) {
      <div class="col-md-12 col-sm-12">
        <mat-form-field class="full-width">
          <mat-label>Tipo de documento</mat-label>
          <mat-select formControlName="codigoTipoDoc">
            <mat-option [value]="'-100'">Todos</mat-option>
            <mat-option [value]="'2'">Circular</mat-option>
            <mat-option [value]="'3'">Memorando</mat-option>
            <mat-option [value]="'4'">Oficio</mat-option>
            <mat-option [value]="'6'">Solicitud</mat-option>
            <mat-option [value]="'7'">Sumilla</mat-option>
          </mat-select>
          <mat-hint>Seleccione el tipo de documento o 'Todos'</mat-hint>
        </mat-form-field>
      </div>
    }

    @if (hasParam ('pFiltroTramite')) {
      <div class="col-md-12 col-sm-12">
        <mat-form-field class="full-width">
          <mat-label>Tipo de tareas</mat-label>
          <mat-select formControlName="filtroTramite">
            <mat-option [value]="'1'">Personal</mat-option>
            <mat-option [value]="'2'">Departamental</mat-option>
          </mat-select>
          <mat-hint>Seleccione el tipo de listado a generar</mat-hint>
        </mat-form-field>
      </div>
    }

    @if (hasParam ('pHoraInicio')) {
      <div class="col-md-6 col-sm-6">
        <mat-form-field class="full-width">
          <mat-label>Hora inicio</mat-label>
          <input matInput type="time" formControlName="horaInicio">
          <mat-hint>HH:MM (default 00:00)</mat-hint>
        </mat-form-field>
      </div>
    }
    @if (hasParam ('pHoraFin')) {
      <div class="col-md-6 col-sm-6">
        <mat-form-field class="full-width">
          <mat-label>Hora fin</mat-label>
          <input matInput type="time" formControlName="horaFin">
          <mat-hint>HH:MM (default 23:59)</mat-hint>
        </mat-form-field>
      </div>
    }
        
    @if (hasParam ('pDepartamento')) {
      <div class="col-md-12 col-sm-12">
        <app-tree-autocomplete
          [dptos]="dsDepartamentos"
          (onSelected)="trackDepartamentoChanges($event)"
          class="full-width"/>
        @if(isEstadisticoReport || isEstadisticoDepartamentalReport) {
          <mat-hint style="font-size:11px;color:var(--mat-sys-error)"></mat-hint>
        }
        @if(isListadoTramitesGeneralPeriodo) {
          <mat-hint style="font-size:11px">Opcional. Si no selecciona, se incluyen todos los departamentos.</mat-hint>
        }
      </div>
    }

    @if (hasParam ('pServidorPublico')) {
      <div class="col-md-12 col-sm-12">
        <mat-form-field class="full-width">
          <mat-label>
            Servidor p&uacute;blico
            @if(isEstadisticoReport) { <span style="font-weight:400;opacity:.7">(opcional)</span> }
          </mat-label>
          <input type="text" matInput formControlName="participante" [matAutocomplete]="autoParticipante"
              (focus)="selectAllText($event)">
          <mat-autocomplete #autoParticipante="matAutocomplete" [displayWith]="displayParticipanteFn">
            @for (participante of participantesFiltered | async; track participante) {
              <mat-option [value]="participante" style="display: block;">
                <div><span>{{participante.apellidos.trim()+" "+participante.nombres.trim()}}</span> </div>
                <small>{{(participante.cargo||'')+" "+participante.ciruc}} </small>
                <span class="sgd-spacer"></span>
                <mat-icon class="ultimo-uso-{{participante.fechaUso|ultimoUso}}"
                    style="float: inline-end; margin-right: 0;">man</mat-icon>
              </mat-option>
            }
          </mat-autocomplete>
          @if(isEstadisticoReport) {
            <mat-hint>Seleccione departamento primero. Dejar vacío para incluir todos.</mat-hint>
          }
        </mat-form-field>
      </div>
    }
    </div>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-button mat-dialog-close type="button">Cancelar</button>
  @if(isTiempoAtencionExportableReport) {
    <button mat-button type="button" (click)="onExportar()">Exportar</button>
  }
  <button mat-button cdkFocusInitial >Aceptar</button>
</mat-dialog-actions>
</form>